import { SITE, absoluteUrl } from "./siteInfo";

/* JSON-LD builders. Each returns a complete object with @context so it can be emitted alone. */

const CTX = "https://schema.org";
const ORG_ID = `${SITE.url}/#organization`;
const SITE_ID = `${SITE.url}/#website`;

export function organization() {
  return {
    "@context": CTX,
    "@type": "Organization",
    "@id": ORG_ID,
    name: SITE.name,
    legalName: SITE.legalName,
    alternateName: "Print Anywhere",
    url: SITE.url,
    logo: { "@type": "ImageObject", url: SITE.logo, width: 512, height: 512 },
    image: SITE.ogImage,
    email: SITE.supportEmail,
    telephone: SITE.phoneE164,
    address: {
      "@type": "PostalAddress",
      streetAddress: SITE.address.street,
      addressLocality: SITE.address.city,
      addressRegion: SITE.address.region,
      postalCode: SITE.address.postalCode,
      addressCountry: SITE.address.country,
    },
    areaServed: SITE.cities.map((c) => ({ "@type": "City", name: c })),
    sameAs: SITE.sameAs,
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: SITE.supportEmail,
        telephone: SITE.phoneE164,
        areaServed: "IN",
        availableLanguage: ["en", "hi", "mr"],
      },
    ],
  };
}

export function website() {
  return {
    "@context": CTX,
    "@type": "WebSite",
    "@id": SITE_ID,
    url: SITE.url,
    name: SITE.name,
    alternateName: "Print Anywhere",
    inLanguage: "en-IN",
    publisher: { "@id": ORG_ID },
  };
}

/* No aggregateRating: Google only accepts ratings collected on the site itself, not store ratings. */
export function mobileApp() {
  return {
    "@context": CTX,
    "@type": "MobileApplication",
    name: SITE.name,
    operatingSystem: "ANDROID, IOS",
    applicationCategory: "UtilitiesApplication",
    installUrl: SITE.playStore,
    downloadUrl: SITE.playStore,
    offers: { "@type": "Offer", price: "0", priceCurrency: "INR" },
    publisher: { "@id": ORG_ID },
    description: SITE.description,
  };
}

export function webPage({ name, path, description }) {
  return {
    "@context": CTX,
    "@type": "WebPage",
    "@id": `${absoluteUrl(path)}#webpage`,
    url: absoluteUrl(path),
    name,
    description,
    isPartOf: { "@id": SITE_ID },
    inLanguage: "en-IN",
  };
}

export function breadcrumbs(items) {
  return {
    "@context": CTX,
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => {
      const li = { "@type": "ListItem", position: i + 1, name: it.name };
      if (i < items.length - 1 && it.path) li.item = absoluteUrl(it.path);
      return li;
    }),
  };
}

export function localBusiness(shop, cityPath) {
  return {
    "@context": CTX,
    "@type": "LocalBusiness",
    "@id": `${absoluteUrl(`${cityPath}/${shop.slug}`)}#shop`,
    name: shop.name,
    url: absoluteUrl(`${cityPath}/${shop.slug}`),
    image: SITE.ogImage,
    address: {
      "@type": "PostalAddress",
      streetAddress: shop.address,
      addressLocality: shop.city,
      addressRegion: shop.state,
      addressCountry: "IN",
    },
    geo: { "@type": "GeoCoordinates", latitude: shop.lat, longitude: shop.lng },
    hasMap: shop.map,
    priceRange: shop.bwFrom ? `₹${shop.bwFrom} per page onwards` : "₹",
    parentOrganization: { "@id": ORG_ID },
    potentialAction: {
      "@type": "OrderAction",
      target: { "@type": "EntryPoint", urlTemplate: absoluteUrl("/print"), actionPlatform: ["http://schema.org/DesktopWebPlatform", "http://schema.org/MobileWebPlatform"] },
    },
  };
}

export function shopList(shops, cityPath) {
  return {
    "@context": CTX,
    "@type": "ItemList",
    itemListElement: shops.map((s, i) => ({ "@type": "ListItem", position: i + 1, url: absoluteUrl(`${cityPath}/${s.slug}`), name: s.name })),
  };
}

export function contactPage() {
  return {
    "@context": CTX,
    "@type": "ContactPage",
    url: absoluteUrl("/contact"),
    name: "Contact PrintAnywhere",
    isPartOf: { "@id": SITE_ID },
    about: { "@id": ORG_ID },
  };
}
